/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {ZoneInstance} from "../models/zone-instance";
import {ZoneService} from "../services/zone.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";

@Injectable()
@Input()
export class ZoneInstancesResolver implements Resolve<ZoneInstance[]> {

  constructor(
    private mZoneService: ZoneService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ZoneInstance[]> {
    try {
      return await this.mZoneService.getAllZoneInstances();
    } catch (error) {
      console.error("Problem resolving Zone Instances... Error: " + error, error);
    }
  }

}
